import type { Pack3DRequest, Pack3DResult } from "./types";
import { buildPacking3DLP, decodePacking3D } from "./packing3dModel";
import { solveLp } from "./highsWorker";

/** Solve a 3D deck-loading instance with HiGHS, returning placements + value. */
export async function solvePacking3D(req: Pack3DRequest): Promise<Pack3DResult> {
  const { cols, rows, maxH, items, timeLimitSec = 30 } = req;

  const t0 = performance.now();
  const { lp, placements, groups } = buildPacking3DLP(items, cols, rows, maxH);
  const tBuildMs = performance.now() - t0;

  // tSolveMs is measured inside the worker around highs.solve() only, so it
  // never includes the one-time WASM init or the wait behind queued solves.
  const { sol, solveMs: tSolveMs } = await solveLp(lp, { time_limit: timeLimitSec, presolve: "on" });

  const solved = sol.Status === "Optimal" || sol.Status === "Feasible";
  const out = solved
    ? decodePacking3D(items, placements, groups, (name) => sol.Columns[name]?.Primal ?? 0)
    : [];
  const value = out.reduce((s, p) => s + p.value, 0);

  const status =
    sol.Status === "Optimal" ? "OPTIMAL" :
    sol.Status === "Feasible" ? "FEASIBLE" :
    String(sol.Status).toUpperCase();

  return {
    status,
    value: Math.round(sol.ObjectiveValue ?? value),
    placements: out,
    tBuildMs,
    tSolveMs,
  };
}
